import { render, staticRenderFns } from "./EmployeesPhoto.vue?vue&type=template&id=8dadd2a2&scoped=true&"
import script from "./EmployeesPhoto.vue?vue&type=script&lang=js&"
export * from "./EmployeesPhoto.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesPhoto.vue?vue&type=style&index=0&id=8dadd2a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dadd2a2",
  null
  
)

export default component.exports